import { calculateBackgroundPositionX, initSlider } from './slider'
import { updateCalculation } from './calculation'
import { findNearestMonth, showAndScrollToForm } from './helper'
import { getCurrencyFormat, getCurrencyFormatNumbersOnly } from '../utils/utils'
import NumberParser from '../leasing-calculator/NumberParser'

function init () {
  const intLeasingCalc = document.getElementById('int-leasing-calc')
  if (!intLeasingCalc) return
  const leasingValueSlider = intLeasingCalc.querySelector('#leasing-value-slider')
  const leasingRuntimeSlider = intLeasingCalc.querySelector('#leasing-runtime-slider')
  const leasingMoneyInput = intLeasingCalc.querySelector('#leasing-money-input')
  const leasingRuntimeDropdown = intLeasingCalc.querySelector('#leasing-runtime-dropdown')
  const provisionSelect = intLeasingCalc.querySelector('#provision-select')
  const countrySelect = intLeasingCalc.querySelector('#country-select')
  const leasingModalButton = intLeasingCalc.querySelector('#leasing-modal-button')
  const leasingResult = intLeasingCalc.querySelector('#leasing-result')
  const leasingCurrencyInMoneyInput = intLeasingCalc.querySelector('#leasing-currency')
  const leasingResultUnit = intLeasingCalc.querySelector('#leasing-result-unit')
  const leasingSubmit = intLeasingCalc.querySelector('#leasing-submit')
  const assetCategory = intLeasingCalc.querySelector('#asset-category')
  const leasingCalcForm = intLeasingCalc.querySelector('#leasing-calculator-form')

  const FALLBACK_LOCALE = 'de-DE'
  const FALLBACK_CURRENCY = 'EUR'
  let minValueleasingValueSlider = 500
  let maxValueleasingValueSlider = 200000

  leasingValueSlider.disabled = true
  leasingMoneyInput.disabled = true
  leasingRuntimeSlider.disabled = true
  leasingRuntimeDropdown.disabled = true

  leasingCalcForm.addEventListener('submit', (e) => e.preventDefault())

  let jsonData
  getJson()
  populateProvisionSelect()
  initializeLeasingValueSliderFromJson(jsonData, leasingValueSlider)
  populateCountryDropdown()
  setLeasingGoal(intLeasingCalc, '0', '0')

  function getJson () {
    const jsonElement = document.getElementById('jsonDataContainer')
    if (jsonElement) {
      jsonData = JSON.parse(jsonElement.getAttribute('data-json'))
    }
  }

  // Helper function to call updateCalculation
  function handleInputChange () {
    const selectedProvision = provisionSelect.value // Get the selected provision
    updateCalculation(
      jsonData,
      leasingRuntimeDropdown,
      leasingMoneyInput,
      countrySelect,
      leasingResult,
      selectedProvision
    )
    updateForm()
  }

  // Event listeners for various inputs that trigger the calculation update
  leasingValueSlider.addEventListener('input', function () {
    updateLeasingMoneyInput(leasingValueSlider.value)
    handleInputChange()
  })
  leasingRuntimeDropdown.addEventListener('change', handleInputChange)
  provisionSelect.addEventListener('change', handleInputChange)
  countrySelect.addEventListener('change', function () {
    initDefaults(jsonData, leasingValueSlider)
    const selectedLocale = countrySelect.value
    const selectedCountry = jsonData.documents.find(
      (doc) => doc.countryAndCurrencyCompoundModel.languageTag === selectedLocale
    )

    populateRuntimeDropdown(selectedCountry)
    leasingRuntimeSlider.removeEventListener('input', updateSliderOnInput)
    populateRuntimeSlider(selectedCountry)

    // set correct currency in the money input-field
    leasingCurrencyInMoneyInput.innerText = selectedCountry.countryAndCurrencyCompoundModel.currency

    // start initial calculation
    updateLeasingMoneyInput(leasingValueSlider.value)
    handleInputChange()

    // update Finance Amount label formating
    updateLeasingValueSliderLabels()

    const isDisabled = !countrySelect.value // if no value is selected, true
    leasingValueSlider.disabled = isDisabled
    leasingMoneyInput.disabled = isDisabled
    leasingRuntimeSlider.disabled = isDisabled
    leasingRuntimeDropdown.disabled = isDisabled
    leasingResultUnit.classList.remove('invisible')
    updateForm()
    leasingSubmit.disabled = false
  })
  leasingModalButton.addEventListener('click', function () {
    $('#int-leasing-calc #leasing-modal').modal('show')
  })
  leasingSubmit.addEventListener('click', function () {
    showAndScrollToForm(intLeasingCalc, this.labels)
    updateForm()
  })

  function initDefaults (jsonData, leasingValueSlider) {
    populateProvisionSelect()
    initializeLeasingValueSliderFromJson(jsonData, leasingValueSlider)
  }

  //build the provision selectbox
  function populateProvisionSelect () {
    if (jsonData && jsonData.provision && jsonData.provision.provisions) {
      provisionSelect.innerHTML = '' // remove first all existing options

      const provisions = jsonData.provision.provisions

      provisions.forEach((provision) => {
        const option = document.createElement('option')
        option.value = provision
        option.text = `${provision}%` // Provision als Prozentwert anzeigen
        provisionSelect.appendChild(option)
      })
    }
  }

  function initializeLeasingValueSliderFromJson (jsonData, leasingValueSlider) {
    if (jsonData && jsonData.labels) {
      minValueleasingValueSlider = Number(jsonData.labels['value-min']) || 500
      maxValueleasingValueSlider = Number(jsonData.labels['value-max']) || 20000
      const initialValueleasingValueSlider = Number(jsonData.labels['value-default']) || 500
      // fill the money input
      const leasingMoneyInputValue = Number(jsonData.labels['value-default']) || 500

      initSlider(
        leasingValueSlider,
        minValueleasingValueSlider,
        maxValueleasingValueSlider,
        initialValueleasingValueSlider
      )

      // set lable
      updateLeasingValueSliderLabels()

      updateLeasingMoneyInput(leasingMoneyInputValue)

      // Event listener for manual changes to the input field
      leasingMoneyInput.addEventListener('change', function () {
        const cleanedMoneyValue = leasingMoneyInput.value.match(/\d|[,.]/g)?.join('') || ''
        const inputValue =
          new NumberParser(countrySelect.value).parse(cleanedMoneyValue) || leasingMoneyInput.value // The entered amount of money
        if (!isNaN(inputValue)) {
          // Debounced checkInputValue
          checkInputValue(
            inputValue,
            minValueleasingValueSlider,
            maxValueleasingValueSlider,
            (adjustedValue) => {
              updateLeasingMoneyInput(adjustedValue)
            }
          )

          // Set the slider value
          leasingValueSlider.value = inputValue

          // Calculate the new background position and set it
          const backgroundPositionX = calculateBackgroundPositionX(
            leasingValueSlider,
            inputValue,
            minValueleasingValueSlider,
            maxValueleasingValueSlider
          )
          leasingValueSlider.style.backgroundPositionX = backgroundPositionX

          handleInputChange()
        }
      })
    }
  }

  function updateLeasingValueSliderLabels () {
    const selectedLocale = countrySelect.value || FALLBACK_LOCALE
    const selectedCurrency = leasingCurrencyInMoneyInput.innerText || FALLBACK_CURRENCY

    let minFormattedNumber = getCurrencyFormatNumbersOnly(
      selectedLocale,
      selectedCurrency,
      minValueleasingValueSlider
    )
    let maxFormattedNumber = getCurrencyFormatNumbersOnly(
      selectedLocale,
      selectedCurrency,
      maxValueleasingValueSlider
    )

    intLeasingCalc.querySelector('#moneyMin').textContent = minFormattedNumber
    intLeasingCalc.querySelector('#moneyMax').textContent = maxFormattedNumber
  }

  // Update the input value based on locale and currency
  function updateLeasingMoneyInput (newValue) {
    const selectedLocale = countrySelect.value || FALLBACK_LOCALE
    const selectedCurrency = leasingCurrencyInMoneyInput.innerText || FALLBACK_CURRENCY

    // Parse the value and ensure it's within the correct format
    let cleanedNewValue = getCurrencyFormatNumbersOnly(selectedLocale, selectedCurrency, newValue)

    // Set the formatted value back in the input
    leasingMoneyInput.value = cleanedNewValue
  }

  function checkInputValue (inputValue, minValueleasingValueSlider, maxValueleasingValueSlider, callback) {
    if (inputValue < minValueleasingValueSlider) {
      callback(minValueleasingValueSlider)
    } else if (inputValue > maxValueleasingValueSlider) {
      $('#int-leasing-calc #leasing-advisory').modal('show')
      callback(maxValueleasingValueSlider)
    } else {
      callback(inputValue)
    }
  }

  function populateCountryDropdown () {
    const defaultOption = document.createElement('option')
    defaultOption.value = ''
    defaultOption.text = jsonData.labels['country-placeholder'] || 'Please select'
    defaultOption.disabled = true
    defaultOption.selected = true
    if (countrySelect) {
      countrySelect.appendChild(defaultOption)
    }

    if (jsonData && jsonData.documents) {
      const sortedCountryData = jsonData.documents.sort((a, b) =>
        a.countryAndCurrencyCompoundModel.displayName.localeCompare(
          b.countryAndCurrencyCompoundModel.displayName
        )
      )
      sortedCountryData.forEach((doc) => {
        const countryModel = doc.countryAndCurrencyCompoundModel
        const displayName = countryModel.displayName
        const locale = countryModel.languageTag

        const optionElement = document.createElement('option')
        optionElement.value = locale
        optionElement.text = displayName

        countrySelect.appendChild(optionElement)
      })
    }
  }

  function setLeasingGoal (leasingGoalContainer, min, max) {
    leasingGoalContainer.querySelector('#goalMin').textContent = min
    leasingGoalContainer.querySelector('#goalMax').textContent = max
  }

  function populateRuntimeDropdown (selectedCountry) {
    leasingRuntimeDropdown.innerHTML = ''

    if (selectedCountry && selectedCountry.monthsAndFactors) {
      const monthsAndFactors = selectedCountry.monthsAndFactors

      Object.keys(monthsAndFactors).forEach((month) => {
        const option = document.createElement('option')
        option.value = month
        option.text = `${month}`
        leasingRuntimeDropdown.appendChild(option)
      })

      // Synchronize the dropdown with the slider value
      leasingRuntimeDropdown.addEventListener('change', function () {
        leasingRuntimeSlider.value = leasingRuntimeDropdown.value

        const backgroundPositionX = calculateBackgroundPositionX(
          leasingRuntimeSlider,
          leasingRuntimeSlider.value,
          leasingRuntimeSlider.min,
          leasingRuntimeSlider.max
        )
        leasingRuntimeSlider.style.backgroundPositionX = backgroundPositionX
      })
    } else {
      const defaultOption = document.createElement('option')
      defaultOption.value = ''
      defaultOption.text = 'Keine Laufzeit verfügbar'
      leasingRuntimeDropdown.appendChild(defaultOption)
    }
  }

  // Function for updating the runtime slider
  let months = []

  function populateRuntimeSlider (selectedCountry) {
    if (selectedCountry && selectedCountry.monthsAndFactors) {
      const monthsAndFactors = selectedCountry.monthsAndFactors

      // Find the minimum and maximum value
      months = Object.keys(monthsAndFactors).map(Number) // The available months as an array
      const minValueRuntimeSlider = Math.min(...months)
      const maxValueRuntimeSlider = Math.max(...months)
      const initialValueRuntimeSlider = minValueRuntimeSlider // Select the minimum value by default

      // Initialize the runtime slider
      initSlider(leasingRuntimeSlider, minValueRuntimeSlider, maxValueRuntimeSlider, initialValueRuntimeSlider)

      // Set labels
      setLeasingGoal(intLeasingCalc, minValueRuntimeSlider.toString(), maxValueRuntimeSlider.toString())

      // Event listener for the slider to display the selected value in the dropdown
      leasingRuntimeSlider.addEventListener('input', updateSliderOnInput)
    }
  }

  function updateSliderOnInput () {
    updateRuntimeSlide()
    handleInputChange()
  }

  function updateRuntimeSlide () {
    const nearestMonth = findNearestMonth(leasingRuntimeSlider.value, months)
    leasingRuntimeDropdown.value = nearestMonth
    updateRuntimeSliderValue(nearestMonth)
  }

  // Slider value synchronization function
  function updateRuntimeSliderValue (value) {
    leasingRuntimeSlider.value = value

    const minValueRuntimeSlider = leasingRuntimeSlider.min
    const maxValueRuntimeSlider = leasingRuntimeSlider.max

    const backgroundPositionX = calculateBackgroundPositionX(
      leasingRuntimeSlider,
      value,
      minValueRuntimeSlider,
      maxValueRuntimeSlider
    )
    leasingRuntimeSlider.style.backgroundPositionX = backgroundPositionX
  }

  function parseAndGetInCurrencyFormat (locale, currency, input) {
    const cleanedMoneyValue = input.match(/\d|[,.]/g)?.join('') || ''
    const moneyValue = new NumberParser(locale).parse(cleanedMoneyValue) || input
    return getCurrencyFormat(locale, currency, moneyValue)
  }

  // Update Form hidden fields with updated calculator values
  function updateForm () {
    const selectedLocale = countrySelect.value || FALLBACK_LOCALE
    const selectedCurrency = leasingCurrencyInMoneyInput.innerText || FALLBACK_CURRENCY

    const submitInputField = intLeasingCalc.querySelector('#CampaignParameter')
    if (submitInputField) {
      submitInputField.value = `
            Finance Amount: ${leasingMoneyInput.value} ${leasingCurrencyInMoneyInput.innerText},
            Finance Runtime: ${leasingRuntimeDropdown.value},
            Monthly Payment: ${leasingResult.innerText} ${leasingCurrencyInMoneyInput.innerText},
            Country: ${countrySelect.options[countrySelect.selectedIndex].text},
            Provision: ${provisionSelect.value},
            Category: ${assetCategory.value}`
    }

    intLeasingCalc.querySelector('#h_value')
      ? (intLeasingCalc.querySelector('#h_value').value = parseAndGetInCurrencyFormat(selectedLocale, selectedCurrency, leasingMoneyInput.value))
      : null
    intLeasingCalc.querySelector('#h_runtime')
      ? (intLeasingCalc.querySelector('#h_runtime').value = leasingRuntimeDropdown.value)
      : null
    intLeasingCalc.querySelector('#h_result')
      ? (intLeasingCalc.querySelector('#h_result').value = leasingResult.innerText)
      : null
    intLeasingCalc.querySelector('#h_category')
      ? (intLeasingCalc.querySelector('#h_category').value = assetCategory.value)
      : null
    intLeasingCalc.querySelector('#h_provision')
      ? (intLeasingCalc.querySelector('#h_provision').value = provisionSelect.value)
      : null
    intLeasingCalc.querySelector('#h_country')
      ? (intLeasingCalc.querySelector('#h_country').value =
        countrySelect.options[countrySelect.selectedIndex].text)
      : null
  }

}

export default {
  init,
}
